import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { apiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { OrbMark } from "../components/Brand";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw !== pw2) return setError("Passwords do not match");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
    } catch (err) {
      setError(apiError(err, "Reset failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 pt-safe" data-testid="reset-password-page"
      style={{ background: "radial-gradient(42rem 42rem at 50% 34%, rgba(124,58,237,0.25), transparent 65%), #07050A" }}>
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-8"><OrbMark size={90} /></div>
        {!token ? (
          <div className="text-center space-y-4">
            <p className="text-sm text-destructive" data-testid="reset-no-token">This reset link is missing its token. Request a new one from the sign-in page.</p>
            <Button variant="ghost" data-testid="reset-goto-login" onClick={() => navigate("/login")}>Back to sign in</Button>
          </div>
        ) : done ? (
          <div className="text-center space-y-4">
            <div className="text-sm text-[#A9C97E] bg-[#4A5D23]/15 border border-[#4A5D23]/40 rounded-md px-3 py-2" data-testid="reset-success">
              Password updated — sign in with your new password.
            </div>
            <Button data-testid="reset-goto-login" onClick={() => navigate("/login")}
              className="w-full bg-primary hover:bg-[#8B5CF6] text-white">Sign in</Button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
            <h2 className="font-heading text-2xl font-semibold text-center">Choose a new password</h2>
            {error && (
              <div data-testid="reset-error" className="text-sm text-destructive bg-destructive/10 border border-destructive/30 rounded-md px-3 py-2">{error}</div>
            )}
            <div className="space-y-2">
              <Label htmlFor="reset-pw">New password</Label>
              <Input id="reset-pw" data-testid="reset-new-password" type="password" required minLength={8}
                value={pw} onChange={(e) => setPw(e.target.value)} className="h-11" placeholder="At least 8 characters" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="reset-pw2">Repeat new password</Label>
              <Input id="reset-pw2" data-testid="reset-confirm-password" type="password" required minLength={8}
                value={pw2} onChange={(e) => setPw2(e.target.value)} className="h-11" />
            </div>
            <Button data-testid="reset-submit" type="submit" disabled={loading}
              className="w-full h-11 bg-primary hover:bg-[#8B5CF6] text-white transition-colors">
              {loading ? "Updating…" : "Set new password"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
